/* eslint-disable @typescript-eslint/no-explicit-any */
import { SidebarLayout } from '@treams/treams-ui';
import * as graphql from 'generated/graphql';
import useViewer from 'packages/kakapo-ui-application/hooks/useViewer';
import { useRouteMatch } from 'react-router-dom';
import Competencies from './Competencies';
import { CompetenciesSidebar } from './CompetenciesSidebar';
import {
	isOwnedJobTitle,
	skillsAnalysisFromJobTitle,
	skillsAnalysisFromUser,
} from './SkillsAnalysis';

function ViewerCatalogCompetencies(props: { jobTitleID: string }) {
	const viewer = useViewer();
	const query = graphql.useJobTitleCompetenciesQuery({
		variables: { id: props.jobTitleID, userID: viewer!.id },
	});

	if (!query.data) {
		return <Competencies.Skeleton />;
	}

	return <Competencies skillsAnalysis={skillsAnalysisFromJobTitle(query.data.jobTitle as any)} />;
}

function ViewerCompetenciesSidebar() {
	const query = graphql.useViewerCompetenciesQuery();

	if (!query.data) {
		return <CompetenciesSidebar.Skeleton />;
	}

	return <CompetenciesSidebar user={query.data.viewer as any} />;
}

function ViewerCompetenciesFactory(props: { userID: string; jobTitleID: string }) {
	const query = graphql.useUserCompetenciesQuery({ variables: { id: props.userID } });

	if (!query.data) {
		return <Competencies.Skeleton />;
	}

	return isOwnedJobTitle(query.data.user as any, props.jobTitleID) ? (
		<Competencies
			owned
			skillsAnalysis={skillsAnalysisFromUser(query.data.user as any, props.jobTitleID)}
		/>
	) : (
		<ViewerCatalogCompetencies jobTitleID={props.jobTitleID} />
	);
}

export default function ViewerCompetencies() {
	const viewer = useViewer();
	const { params } = useRouteMatch<{ jobTitleID: string }>();

	return (
		<SidebarLayout sidebar={<ViewerCompetenciesSidebar />}>
			<ViewerCompetenciesFactory userID={viewer!.id} jobTitleID={params.jobTitleID} />
		</SidebarLayout>
	);
}
